const getParameters = () => {
    const location = window.location;
    const result = {};
    const params = location.href.substring(location.href.indexOf("?") + 1).split("&")
        .concat(location.hash.substring(location.hash.indexOf("?") + 1).split("&"))

    params.forEach(v => {
        var kvp = v.split("=");
        result[kvp[0]] = decodeURIComponent(kvp[1]);
    });

    return result;
};

export default {
    getParameters
};